define.alias("shared/components/shared/plan-recommendation/progress-bar", "media/components/shared/plan-recommendation/progress-bar");